 import Vue from 'vue'
// import { initializeApp } from "firebase/app";
// import { getDatabase, ref, onValue,  child, push, update, set, get  } from "firebase/database";

Vue.prototype.$money = function (amount) {
  if (!amount) { amount = 0 }
  if (isNaN(amount)) {
    amount = 0
  }
  amount = parseFloat(amount).toFixed(2)
  return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

Vue.prototype.$IsNum = function (input) {
  if (isNaN(parseFloat(input)) || input == null) {
    return 0
  }
  input = parseFloat(input).toFixed(2)
  return parseFloat(input)
}
Vue.prototype.$printThis = function () {
    window.print()
}
Vue.prototype.$groupBy = key => array =>
  array.reduce((objectsByKeyValue, obj) => {
    const value = obj[key]
    objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj)
    return objectsByKeyValue
  }, {})

// const firebaseConfig = {
//     apiKey: "AIzaSyALQOIHRRXpdISmuSpuU0Vd-ybPHQoHfuU",
//     authDomain: "inventory-management-sys-87881.firebaseapp.com",
//     databaseURL: "https://inventory-management-sys-87881.firebaseio.com",
//     projectId: "inventory-management-sys-87881",
//     storageBucket: "inventory-management-sys-87881.appspot.com",
//     messagingSenderId: "383261390108",
//     appId: "1:383261390108:web:4f57637c0399f29723b6d9",
//     measurementId: "G-3K9YP4MG2F"
// };
// const app = initializeApp(firebaseConfig);
// Vue.prototype.$FBDB =  getDatabase(app) 
// Vue.prototype.$refdb =  ref
// Vue.prototype.$onValuedb =  onValue
// Vue.prototype.$childdb =  child
// Vue.prototype.$pushdb =  push
// Vue.prototype.$updatedb  =  update 
// Vue.prototype.$getdb  =  get 
// Vue.prototype.$setdb  =  set

